export const ADD_LENSES_SUCCESS = 'ADD_LENSES_SUCCESS';
export const LIST_ALL_LENSE_SUCCESS = 'LIST_ALL_LENSE_REQUEST_SUCCESS';
export const UPDATE_LENSES_SUCCESS = 'UPDATE_LENSES_SUCCESS';
export const LIST_ALL_LENSE_REQUEST = 'LIST_ALL_LENSE_REQUEST';
export const LIST_ALL_LENSE_FAILURE = 'LIST_ALL_LENSE_FAILURE';
export const DELETE_LENSE_SUCCESS = 'DELETE_LENSE_SUCCESS';
export const CREATE_LENSES_SUCCESS = 'CREATE_LENSES_SUCCESS';
